 const settingNames = {
  LED_MODE: "LED Mode",
  VIBRATION_MODE: "Vibrate Mode",
  CLEANING_MODE: "Cleaning Mode",
  RESPONSIVE_DRAW: "Responsive Draw",
  VAPE_CLOUD_SIZE: "Vape Cloud Size",
  AUTO_START: "Auto Start",
  SMART_GESTURES: "Smart Gestures",
  RESTART_MODE: "Restart"
};

export default settingNames;
